// extracted by mini-css-extract-plugin
export default {"headerCombinedWrapper":"HeaderCombined_headerCombinedWrapper__mMG8I"};